/**
 * Logic for the Find Your Project filter/search on the homepage.
 */
(function(jQuery) {
    'use strict';

    function ProjectsAbroadFindProject() {
        var global = {
            mediaQueryWidth: 992,
            snippetsHelper: require('./snippets-helper'),
        };

        var fn = {
            init: function() {
                var findProject = jQuery('.TypeFindProject');

                //mobile - open lateral menu clicking on the menu icon
                findProject
                    .find('.FilterBar-trigger')
                    .on('click', global.snippetsHelper.showFilters);

                //open submenu (For Home Find Your Project search in Hero image)
                findProject
                    .find('.TypeFindProject__filter')
                    .on('click', global.snippetsHelper.openProductsFilter);

                findProject
                    .find('.FilterBar__clear-all')
                    .on('click', function() {
                        jQuery(
                            '.FilterBar__select:checked:not(.FilterBar__select--all)'
                        ).prop('checked', false);
                        global.snippetsHelper.closeBar();
                        fn.updateOptions();
                        global.snippetsHelper.scrollToFilters();
                    });

                findProject.find('.FilterBar__back').on('click', function() {
                    jQuery(this)
                        .closest('ul.FilterBar-nav')
                        .addClass('is-hidden');
                    fn.updateOptions();
                });

                findProject
                    .find('.FilterBar-overlay, .FilterBar__close')
                    .on('click', function() {
                        fn.updateOptions();
                        global.snippetsHelper.updateCounters();
                    });

                findProject
                    .find('.FilterBar__actions--see, .FilterBar__actions--done')
                    .on('click', function() {
                        fn.submit();
                    });

                // // Only update options making an ajax call if there is a find project section on the page
                // findProject.on('load', function () {
                // 	fn.updateOptions();
                // 	global.snippetsHelper.updateCounters();
                // })
            },

            submit: function() {
                jQuery('.TypeFindProject__submit').trigger('click');
            },

            moveBar: function() {
                var navigation = jQuery('.cd-nav');
                var desktop = fn.checkWindowWidth();
                if (desktop) {
                    navigation.detach();
                    navigation.insertBefore('.cd-header-buttons');
                } else {
                    navigation.detach();
                    navigation.insertAfter('.cd-main-content');
                }
            },

            updateOptions: function() {
                var serialFilters = jQuery(
                    '#TypeFindProject__form'
                ).serializeArray();

                var filters = {
                    'available-options-only-ps': true,
                };

                serialFilters.forEach(function(filter) {
                    var filterName = filter.name;
                    if (filterName.indexOf('destinations') !== -1) {
                        filterName = 'destinations-ps';
                    } else if (filterName.indexOf('projects') !== -1) {
                        filterName = 'type-of-work-tags-ps';
                    } else {
                        return;
                    }

                    if (filterName in filters) {
                        filters[filterName] += ',' + filter.value;
                    } else {
                        filters[filterName] = filter.value;
                    }
                });

                jQuery.get(
                    '/product-snippets/',
                    filters,
                    function(data) {
                        if (!data.availableOptions) {
                            data.availableOptions = [];
                        }

                        var options = jQuery('.FilterBar__select').not(
                            '.FilterBar__select--all'
                        );
                        options.each(function() {
                            var option = jQuery(this);
                            option.prop(
                                'disabled',
                                data.availableOptions.indexOf(option.val()) ===
                                    -1
                            );
                        });

                        global.snippetsHelper.checkedChildrenEnabled();
                        global.snippetsHelper.updateCounters();
                    },
                    'json'
                );
            },
        };

        jQuery(fn.init);
    }

    new ProjectsAbroadFindProject();
})($);
